
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h13.406l.313.281 6 6 .281.313V29H5V3zm2 2v22h16V11h-6V5H7zm12 1.438v2.563h2.563zM20.094 14a1 1 0 110 2 1 1 0 010-2zM13 15.594l.719.688L16 18.563l1.281-1.281.719-.688.719.688 3 3-1.438 1.438L18 19.439l-1.281 1.281-.719.688-.719-.688L13 18.439 9.719 21.72l-1.438-1.438 4-4z"}})])
          )
        }
      }
    